import React from 'react'
import cx from 'classnames'
import './styles.sass'

const SocialIcon = ({ icon, url }) => (
  <a href={url} className="social-icon" target="_blank" rel="noopener noreferrer">
    <i className={cx('fa', `fa-${icon}`)}></i>
  </a>
)

const Footer = () => (
  <footer className="page-footer">
    <div className="columns">
      <div className="column is-narrow logo-column">
        <img src={require('assets/img/taxfyle-logo-icon.png')} className="logo" />
      </div>
      <div className="column links">
        <a href="https://taxfyle.com/partners" target="_blank" rel="noopener noreferrer">Partners</a>
        <a href="https://intercom.help/taxfyle" target="_blank" rel="noopener noreferrer">FAQ</a>
        <a href="https://taxfyle.com/policies/terms" target="_blank" rel="noopener noreferrer">Terms of Use</a>
        <a href="https://taxfyle.com/policies/privacy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
      </div>
      <div className="column is-narrow links">
        <SocialIcon icon="facebook" url="https://facebook.com/Taxfyle" />
        <SocialIcon icon="twitter" url="https://twitter.com/Taxfyle" />
        <SocialIcon icon="instagram" url="https://instragram.com/Taxfyle" />
        <SocialIcon icon="youtube" url="https://www.youtube.com/channel/UChipeQJrmT2-qqZCnSidjuw" />
      </div>
      <div className="column is-narrow">
        Copyright &copy; Tickmark, Inc {new Date().getFullYear()}
      </div>
    </div>
  </footer>
)

export default Footer



// WEBPACK FOOTER //
// ./src/client/components/Footer/index.jsx